export default function PHP_current() {
  return (
    <div>
      <h1>PHP_current</h1>
    </div>
  );
}
